import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-component-replace-ables',
  templateUrl: './component-replace-ables.component.html',
  styleUrls: ['./component-replace-ables.component.css']
})
export class ComponentReplaceAblesComponent implements OnInit {
    compKeyno;

    public setting?: Setting;

    public grid?: GridOptions;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.compKeyno = this.stateService.getStateParams()['comp_keyno'];
    }

    private async loadSetting() {
        if (!!this.compKeyno) {
            this.setting = (await this.datatask.Post(3739, { comp_keyno: this.compKeyno }))[0];
        }
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('componentreplaceables_grid')
                .setLoadDataFunction({
                    method: 3740,
                    parameters: () => this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public async saveChanges() {
        if (!!this.setting) {
            try {
                this.saving = true;

                const selectedItems = (this.grid?.gridfunc?.getDirtyRows() ?? []).filter((row) => row['is_selected'] === true).map((row) => ({ choice_prod_id: row['choice_prod_id'] }));

                const mergeObj = {
                	...this.setting,
                	records: selectedItems
                }

                const response = (await this.datatask.Post(3741, mergeObj))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    prod_id: string;
    prod_name: string;
    component_id: string;
    component_name: string;
    comp_keyno: string;
}
